var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessManipulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 23.375C20.383 23.375 14.875 22.0448 14.875 19.125C14.875 16.2053 20.383 14.875 25.5 14.875C30.617 14.875 36.125 16.2053 36.125 19.125C36.125 22.0448 30.617 23.375 25.5 23.375ZM25.5 17C19.9219 17 17 18.5789 17 19.125C17 19.6711 19.9219 21.25 25.5 21.25C31.0781 21.25 34 19.6711 34 19.125C34 18.5789 31.0781 17 25.5 17Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 36.125C20.383 36.125 14.875 34.7947 14.875 31.875V19.125C14.875 18.5385 15.351 18.0625 15.9375 18.0625C16.524 18.0625 17 18.5385 17 19.125V31.875C17 32.4211 19.9219 34 25.5 34C31.0781 34 34 32.4211 34 31.875V19.125C34 18.5385 34.476 18.0625 35.0625 18.0625C35.649 18.0625 36.125 18.5385 36.125 19.125V31.875C36.125 34.7947 30.617 36.125 25.5 36.125Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 29.75C20.383 29.75 14.875 28.4197 14.875 25.5C14.875 24.9135 15.351 24.4375 15.9375 24.4375C16.524 24.4375 17 24.9135 17 25.5C17 26.0461 19.9219 27.625 25.5 27.625C31.0781 27.625 34 26.0461 34 25.5C34 24.9135 34.476 24.4375 35.0625 24.4375C35.649 24.4375 36.125 24.9135 36.125 25.5C36.125 28.4197 30.617 29.75 25.5 29.75Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63625 31.875C1.14963 31.875 0.711875 31.5392 0.601375 31.0462C0.201875 29.2782 0 27.4125 0 25.5C0 11.4389 11.4389 0 25.5 0C33.575 0 41.2441 3.88875 46.0126 10.4019C46.359 10.8757 46.257 11.5409 45.7831 11.8872C45.3093 12.2357 44.6441 12.1295 44.2978 11.6578C39.9288 5.68863 32.8993 2.125 25.5 2.125C12.6119 2.125 2.125 12.6119 2.125 25.5C2.125 27.2574 2.30988 28.9659 2.67325 30.5788C2.80288 31.1525 2.44375 31.7199 1.87 31.8495C1.79138 31.8665 1.71275 31.875 1.63625 31.875V31.875Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 51C17.3635 51 9.66035 47.0624 4.89822 40.4664C4.55397 39.9904 4.66235 39.3252 5.13622 38.9831C5.61435 38.6367 6.27522 38.7451 6.61947 39.2211C10.9863 45.2667 18.0435 48.875 25.5001 48.875C38.3882 48.875 48.8751 38.3881 48.8751 25.5C48.8751 23.7192 48.686 22.0129 48.3098 20.434C48.1738 19.8624 48.5266 19.2886 49.0982 19.1547C49.6741 19.0166 50.2436 19.3715 50.3775 19.9431C50.7897 21.6835 51.0001 23.5535 51.0001 25.5C51.0001 39.5611 39.5612 51 25.5001 51V51Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.41878 51C4.83653 51 4.36266 50.5304 4.35628 49.9481L4.25003 39.3231C4.24791 39.0405 4.35841 38.7664 4.55816 38.5666C4.75791 38.3626 5.02991 38.25 5.31253 38.25H15.9375C16.524 38.25 17 38.726 17 39.3125C17 39.899 16.524 40.375 15.9375 40.375H6.38566L6.48128 49.9269C6.48766 50.5134 6.01803 50.9936 5.42941 51C5.42728 51 5.42303 51 5.41878 51V51Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6875 12.75H35.0625C34.476 12.75 34 12.274 34 11.6875C34 11.101 34.476 10.625 35.0625 10.625H44.625V1.0625C44.625 0.476 45.101 0 45.6875 0C46.274 0 46.75 0.476 46.75 1.0625V11.6875C46.75 12.274 46.274 12.75 45.6875 12.75Z",
    fill: "url(#paint6_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.4616,
    y1: 23.375,
    x2: 25.4616,
    y2: 14.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 25.4616,
    y1: 36.125,
    x2: 25.4616,
    y2: 18.0625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.4616,
    y1: 29.75,
    x2: 25.4616,
    y2: 24.4375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 23.0255,
    y1: 31.875,
    x2: 23.0255,
    y2: -0.00000133275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 27.7649,
    y1: 51,
    x2: 27.7649,
    y2: 19.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 10.602,
    y1: 51,
    x2: 10.602,
    y2: 38.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 40.352,
    y1: 12.75,
    x2: 40.352,
    y2: -5.33099e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessManipulation);
export default __webpack_public_path__ + "static/media/process--manipulation.5ecd4f12b70b0c2f9a50b1019b42b854.svg";
export { ForwardRef as ReactComponent };